export default __webpack_public_path__ + "static/media/I36.17af4d71.jpg";